import React from "react";

import { INLINE_STYLE, BLOCK_TYPE } from "draftail"
import { ENTITY_TYPE } from './api/constants'

import LinkSource from "./sources/link-source";
import ImageSource from "./sources/image-source";

import Link from "./entities/link";
import LinkReadOnly from  "./entities/link-read-only";

export const BR_ICON = "M.436 633.471l296.897-296.898v241.823h616.586V94.117h109.517v593.796H297.333v242.456z";

export const INLINE_CONTROL = {
    BOLD:           { type: INLINE_STYLE.BOLD,          gdIcon: "editor-i5-bold" },
    ITALIC:         { type: INLINE_STYLE.ITALIC,        gdIcon: "editor-i5-italic" },
    STRIKETHROUGH:  { type: INLINE_STYLE.STRIKETHROUGH, gdIcon: "editor-i5-strikethrough"},
    MARK:           { type: INLINE_STYLE.MARK,          gdIcon: "i5-pen"},
    CODE:           { type: INLINE_STYLE.CODE,          gdIcon: "editor-i5-code" },
    UNDERLINE:      { type: INLINE_STYLE.UNDERLINE,     gdIcon: "editor-i5-underline" },
    SUBSCRIPT:      { type: INLINE_STYLE.SUBSCRIPT,     gdIcon: "editor-i5-subscript" },
    SUPERSCRIPT:    { type: INLINE_STYLE.SUPERSCRIPT,   gdIcon: "editor-i5-superscript" },

    // QUOTATION:      { type: INLINE_STYLE.QUOTATION,     gdIcon: "editor-i5-quote" },
    // SMALL:          { type: INLINE_STYLE.SMALL,         gdIcon: "ii5-zzz" },
    // SAMPLE:         { type: INLINE_STYLE.SAMPLE,        icon: "#icon-lab" },
    // INSERT:         { type: INLINE_STYLE.INSERT,        label: "Ins" },
    // DELETE:         { type: INLINE_STYLE.DELETE,        label: "Del" },
    // KEYBOARD:       { type: INLINE_STYLE.KEYBOARD,      gdIcon: ""  },
};

export const BLOCK_CONTROL = {
    UNSTYLED:               { type: BLOCK_TYPE.UNSTYLED },
    HEADER_ONE:             { type: BLOCK_TYPE.HEADER_ONE },
    HEADER_TWO:             { type: BLOCK_TYPE.HEADER_TWO },
    HEADER_THREE:           { type: BLOCK_TYPE.HEADER_THREE },
    // HEADER_FOUR:            { type: BLOCK_TYPE.HEADER_FOUR },
    // HEADER_FIVE:            { type: BLOCK_TYPE.HEADER_FIVE },
    // HEADER_SIX:             { type: BLOCK_TYPE.HEADER_SIX },
    BLOCKQUOTE:             { type: BLOCK_TYPE.BLOCKQUOTE,              gdIcon: "editor-i5-quote" },
    CODE:                   { type: BLOCK_TYPE.CODE,                    gdIcon: "editor-i5-code" },
    UNORDERED_LIST_ITEM:    { type: BLOCK_TYPE.UNORDERED_LIST_ITEM,     gdIcon: "editor-i5-bullet-list" },
    ORDERED_LIST_ITEM:      { type: BLOCK_TYPE.ORDERED_LIST_ITEM,       gdIcon: "editor-i5-numbered-list" },
};

export const ENTITY_CONTROL = {
    LINK: {
        type: ENTITY_TYPE.LINK,
        gdIcon: "editor-i5-link",
        source: LinkSource,
        decorator: Link,
        // attributes: ["url"],
        whitelist: {
            href: "^(?![#/])",
        },
    },
    LINK_READ_ONLY: {
        type: ENTITY_TYPE.LINK,
        gdIcon: "editor-i5-link",
        source: LinkSource,
        decorator: LinkReadOnly,
        // attributes: ["url"],
        whitelist: {
            href: "^(?![#/])",
        },
    },
    IMAGE: {
        type: ENTITY_TYPE.IMAGE,
        description: "Image",
        gdIcon: "editor-i5-image",
        source: ImageSource,
        // attributes: ["src", "alt"], //because of this width and height attributes cleared out
        whitelist: {
            src: "^(?!(data:|file:))",
        },
    },
    ATTACHMENT: {
        type: ENTITY_TYPE.ATTACHMENT,
        /*description: "Attachment",
        gdIcon: "editor-i5-image",
        source: ImageSource,
        // attributes: ["src", "alt"], //because of this width and height attributes cleared out
        whitelist: {
            src: "^(?!(data:|file:))",
        },*/
    }
};